import { render, staticRenderFns } from "./sleepBreatheWeek.vue?vue&type=template&id=5768bc08&scoped=true&"
import script from "./sleepBreatheWeek.vue?vue&type=script&lang=js&"
export * from "./sleepBreatheWeek.vue?vue&type=script&lang=js&"
import style0 from "./sleepBreatheWeek.vue?vue&type=style&index=0&id=5768bc08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5768bc08",
  null
  
)

export default component.exports